export function isEditableShortcutTarget(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false

  const tagName = target.tagName.toLowerCase()
  const contentEditable = target.getAttribute('contenteditable')
  if (
    target.isContentEditable ||
    contentEditable === '' ||
    contentEditable === 'true' ||
    contentEditable === 'plaintext-only'
  ) {
    return true
  }

  return tagName === 'input' || tagName === 'textarea' || tagName === 'select'
}

function getNormalizedShortcutKey(event: Pick<KeyboardEvent, 'key'>): string | null {
  return typeof event.key === 'string' ? event.key.toLowerCase() : null
}

export function shouldIgnoreRouteModeShortcut(
  event: Pick<KeyboardEvent, 'target' | 'defaultPrevented'>,
  isDialogOpen: boolean,
): boolean {
  return isDialogOpen || event.defaultPrevented || isEditableShortcutTarget(event.target)
}

export function isUndoRouteModeShortcut(
  event: Pick<KeyboardEvent, 'key' | 'metaKey' | 'ctrlKey' | 'altKey' | 'shiftKey' | 'repeat'>,
): boolean {
  const key = getNormalizedShortcutKey(event)

  return (
    !event.repeat &&
    !event.metaKey &&
    event.ctrlKey &&
    !event.altKey &&
    !event.shiftKey &&
    key === 'z'
  )
}

export function isRedoRouteModeShortcut(
  event: Pick<KeyboardEvent, 'key' | 'metaKey' | 'ctrlKey' | 'altKey' | 'shiftKey' | 'repeat'>,
): boolean {
  const key = getNormalizedShortcutKey(event)

  const isCtrlShiftZRedo =
    !event.repeat &&
    !event.metaKey &&
    event.ctrlKey &&
    !event.altKey &&
    event.shiftKey &&
    key === 'z'

  const isCtrlYRedo =
    !event.repeat &&
    !event.altKey &&
    !event.shiftKey &&
    !event.metaKey &&
    event.ctrlKey &&
    key === 'y'

  return isCtrlShiftZRedo || isCtrlYRedo
}

export function isCloseRouteModeShortcut(
  event: Pick<KeyboardEvent, 'key' | 'metaKey' | 'ctrlKey' | 'altKey' | 'shiftKey' | 'repeat'>,
): boolean {
  const key = getNormalizedShortcutKey(event)

  return (
    !event.repeat &&
    !event.metaKey &&
    !event.ctrlKey &&
    !event.altKey &&
    !event.shiftKey &&
    key === 's'
  )
}
